import link from '../../link/default';

const secondary = (params) => link.secondary(params);

export default secondary;
